import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import logo from "@/assets/brand/note-console-logo-transparent.png";
import OrderNowLink from "@/components/OrderNowLink";
import { LAUNCH_COUPON_CODE, LAUNCH_COUPON_DISCOUNT } from "@/lib/order";

export default function Footer() {
  return (
    <footer className="mt-24 border-t-[3px] border-retro-ink bg-retro-cream paper-grain" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <img src={logo} alt="Note Console" className="h-20 w-auto object-contain" />
          </div>
          <p className="font-hand text-2xl text-retro-purple max-w-md">
            NoteConsole — Plan your days. Capture your thoughts. Track your life.
          </p>
          <p className="font-body text-sm mt-3 max-w-md text-retro-ink/80">
            A digital planner and diary workspace with a private memory dashboard. Built for journalers, students, dreamers and growth-trackers.
          </p>
          <OrderNowLink source="footer" className="retro-btn mt-5 inline-flex bg-retro-yellow px-4 py-2 font-body text-sm font-bold text-retro-ink" />
        </div>
        <div>
          <h4 className="font-pixel text-[10px] mb-3">EXPLORE</h4>
          <ul className="space-y-2 font-body text-sm">
            <li><a href="/#how" className="hover:text-retro-purple">How It Works</a></li>
            <li><a href="/#pdf-showcase" className="hover:text-retro-purple">Planner Pages</a></li>
            <li><a href="/#features" className="hover:text-retro-purple">Features</a></li>
            <li><a href="/#order" className="hover:text-retro-purple">Order Now</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-pixel text-[10px] mb-3">LAUNCH</h4>
          <ul className="space-y-2 font-body text-sm">
            <li>Coupon {LAUNCH_COUPON_CODE}</li>
            <li>{LAUNCH_COUPON_DISCOUNT} off for first 500 loyal users</li>
            <li><Link to="/terms" className="hover:text-retro-purple">Terms & Conditions</Link></li>
            <li><Link to="/login" className="hover:text-retro-purple">Admin Login</Link></li>
            <li><Link to="/admin/submissions" className="hover:text-retro-purple">Form Responses</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t-[2px] border-retro-ink/30 py-4 px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-body">
        <p>© {new Date().getFullYear()} Note Console</p>
        <p className="flex items-center gap-1">Made with <Heart className="text-retro-pink" size={14} fill="currentColor" /> for planner lovers</p>
      </div>
    </footer>
  );
}
